<template>
  <BContainer
    class="vh-100 d-flex justify-content-center align-items-center flex-column background"
    fluid
  >
    <div
      class="signin-container bg-signin p-3"
      style="border-radius: 24px;"
    >
      <div class="signin-content d-flex flex-column align-items-center">

        <div class="d-flex flex-column justify-content-start w-100">
          <div class="d-flex justify-content-end">
            <div
              id="theme-mode-toggler"
              class="w-35px min-h-35px d-flex justify-content-center align-items-center bg-hover-primary-light cursor-pointer rounded-lg mb-1"
              @click.prevent="darkChange(!darkMode)"
            >
              <div class="px-2">
                <!-- <i class="fad fa-key h5 text-primary mb-0" /> -->
                <i
                  v-if="darkMode"
                  class="fa-xl fad fa-brightness mb-0"
                />
                <i
                  v-else
                  class="fa-xl fad fa-moon mb-0"
                />
              </div>
            </div>
            <!-- <BPopover
              target="theme-mode-toggler"
              triggers="hover"
              placement="auto"
              class="rounded-lg"
            >
              Toggling between light and dark mode.
            </BPopover> -->
          </div>
          <div class="d-flex flex-column align-items-center">
            <i
              class="fad fa-pig text-secondary border border-secondary p-3"
              style="font-size: 32px; border-radius: 50%;"
            />
            <div class="d-flex flex-column align-items-center mt-2">
              <h3>CRMS</h3>
              <h6
                class="text-center"
                style="font-size: 14px; font-weight: 500; color: #999;"
              >
                Customer Relationship Management System
              </h6>
            </div>
          </div>
        </div>

        <div class="signin-form">
          <ValidationObserver
            ref="signinForm"
            v-slot="{ handleSubmit }"
          >
            <form
              role="form"
              novalidate
              @submit.prevent="handleSubmit(onSignIn)"
            >
              <div
                class="rounded py-2 px-2"
              >
                <BRow>
                  <BCol
                    cols="12"
                  >
                    <BRow>
                      <BCol
                        cols="12"
                      >
                        <ValidationProvider
                          v-slot="{ errors }"
                          vid="username"
                          name="username"
                          rules="required"
                        >
                          <BFormGroup
                            label="Username"
                            label-for="username"
                            label-class="font-weight-bold"
                            class="mb-2"
                          >
                            <BFormInput
                              id="username"
                              v-model="credentials.username"
                              type="text"
                              size="sm"
                              placeholder="enter username here"
                              autocomplete="off"
                              :state="errors.length > 0 ? false : null"
                              :disabled="state.busy"
                            />
                            <div
                              v-if="errors.length > 0"
                              class="invalid-feedback"
                              v-text="errors[0]"
                            />
                          </BFormGroup>
                        </ValidationProvider>
                      </BCol>

                      <BCol
                        cols="12"
                      >
                        <ValidationProvider
                          v-slot="{ errors }"
                          vid="password"
                          name="password"
                          rules="required"
                        >
                          <BFormGroup
                            label="Password"
                            label-for="password"
                            label-class="font-weight-bold"
                            class="mb-2"
                          >
                            <BInputGroup
                              :class="errors.length > 0 ? 'is-invalid' : ''"
                            >
                              <BFormInput
                                id="password"
                                v-model="credentials.password"
                                size="sm"
                                placeholder="enter password here"
                                autocomplete="off"
                                :type="passwordType"
                                :state="errors.length > 0 ? false : null"
                                :disabled="state.busy"
                              />
                              <BInputGroupAppend>
                                <BButton
                                  class="pl-2 pr-0 text-dark input-icon"
                                  variant="light"
                                  :disabled="state.busy"
                                  @click.prevent="togglePassword"
                                >
                                  <i
                                    v-if="state.visible_password"
                                    class="fad fa-eye h6 mb-0 min-w-40px"
                                  />
                                  <i
                                    v-else
                                    class="fad fa-eye-slash h6 mb-0 min-w-40px"
                                  />
                                </BButton>
                              </BInputGroupAppend>
                            </BInputGroup>
                            <div
                              v-if="errors.length > 0"
                              class="invalid-feedback"
                              v-text="errors[0]"
                            />
                          </BFormGroup>
                        </ValidationProvider>
                      </BCol>

                    </BRow>
                  </BCol>
                </BRow>
                <BRow class="px-2 pt-2">

                  <BCol
                    cols="12"
                    class="px-1"
                  >
                    <BOverlay
                      rounded
                      opacity="0.1"
                      spinner-variant="secondary"
                      spinner-small
                      :show="state.local"
                    >
                      <BButton
                        size="sm"
                        type="submit"
                        class="w-100 font-weight-bolder"
                        variant="primary"
                        :disabled="state.busy"
                      >
                        Sign In
                      </BButton>
                    </BOverlay>
                  </BCol>

                  <BCol class="text-divider">
                    <span>&nbsp; or sign in with</span>
                  </BCol>

                  <BCol
                    cols="12"
                    class="px-1"
                  >
                    <BOverlay
                      rounded
                      opacity="0.1"
                      spinner-variant="primary"
                      spinner-small
                      :show="state.sso"
                    >
                      <BButton
                        size="sm"
                        type="button"
                        class="w-100 font-weight-bolder"
                        variant="secondary"
                        :disabled="state.busy"
                        @click.prevent="onSignInWithAljaySSO"
                      >
                        Aljay SSO
                      </BButton>
                    </BOverlay>
                  </BCol>
                </BRow>
              </div>

            </form>
          </ValidationObserver>
        </div>
      </div>

    </div>
  </BContainer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Oauth2 } from 'universal-social-auth'
import { setClusters } from '@/forage/shared/clusters'

import URL from '@/mixins/image-url'

import { SSharedAuth, SSharedSSO } from '@/services/shared'

export default {
  name: 'SharedLogin',

  mixins: [
    URL
  ],

  middleware: ['guest'],

  metaInfo: () => ({
    title: 'Sign In'
  }),

  data: () => ({
    state: {
      busy: false,
      local: false,
      sso: false,
      visible_password: false
    },
    credentials: {
      username: '',
      password: ''
    },
    singleSignOn: Oauth2
  }),

  computed: {
    ...mapGetters({
      darkMode: 'settings/darkModeState',
      user: 'auth/user'
    }),

    companyLogo () {
      return this.transformToImageUrl(this.getCompany())
    },

    passwordType () {
      return this.state.visible_password ? 'text' : 'password'
    }

  },

  methods: {

    togglePassword () {
      this.state.visible_password = !this.state.visible_password
    },

    async saveAndGetCurrentUser (token) {
      this.$store.dispatch('auth/saveToken', token)
      this.$store.dispatch('customer-management/isUserLoggingOutAction', false)

      return new Promise((resolve, reject) => {
        SSharedAuth.getCurrentUser().then(
          ({ data }) => {
            setClusters(data?.clusters || [])
            this.$store.dispatch('auth/fetchUserSuccess', {
              id: data.id,
              email: data.email,
              team: data.team?.id,
              team_code: data.team?.team_code,
              team_name: data.team?.team_name,
              area: data.area?.id,
              area_code: data.area?.area_code,
              area_name: data.area?.area_name,
              role_id: data.role?.id,
              role: data.role?.role_code,
              role_name: data.role?.role_name,
              username: data.username,
              name: data.name,
              first_name: data.first_name,
              last_name: data.last_name,
              mobile_number: data.mobile_number,
              notification_email: data.notification_email,
              photo_url: data.photo_url,
              can_verify: data.can_verify
            })

            const user = this.$store.getters['auth/user']

            this.$router.replace({
              name: user ? `${user.role}.dashboard` : 'dashboard'
            }, () => {
              resolve(data)
            })
          }
        ).catch(error => {
          this.$store.dispatch('auth/fetchUserFailure')
          reject(error)
        })
      })
    },

    async onSignIn () {
      await this.$refs.signinForm.validate().then(
        allFieldsAreValid => {
          if (allFieldsAreValid) {
            this.state.busy = this.state.local = true
            SSharedAuth.signIn(this.credentials).then(
              ({ data: { token } }) => {
                this.saveAndGetCurrentUser(token).finally(() => {
                  this.state.busy = this.state.local = false
                })
              }
            ).catch(() => {
              this.state.busy = this.state.local = false
            })
          }
        }
      )
    },

    async onSignInWithAljaySSO (event) {
      event.preventDefault()
      this.state.busy = this.state.sso = true
      this.$usAuth.authenticate('oauth2', this.singleSignOn).then(
        authorized => {
          SSharedSSO.post(authorized).then(
            ({ data: { token } }) => {
              this.saveAndGetCurrentUser(token).finally(() => {
                this.state.busy = this.state.local = false
              })
            }
          ).catch(() => {
            this.state.busy = this.state.sso = false
          })
        }
      )
    },

    darkChange (mode) {
      this.modeChange({ rtl: false, dark: mode })
    },

    ...mapActions({
      modeChange: 'settings/layoutModeAction'
    })
  }
}
</script>

<style scoped lang="scss">
  .signin-container {
    max-width: 85vw;
  }

  @media (min-width: 768px) {
    .signin-container {
      max-width: 375px;
    }
  }

  @media screen and (orientation: landscape) and (min-width: 576px) and (max-height: 430px) {
    .signin-container {
      max-width: 85vw;
      .signin-content {
        flex-direction: row !important;
        gap: 2rem;
        .signin-form {
          max-width: 300px;
        }
      }
    }
  }

  .background {
    /*
     * Rice field with tree image featuring:
     * - Clouds: #F9F8F1
     * - Sky: #00A5FE
     * - Rice field: #58DC00 and #005032
     */
    background: var(--iq-body-bg);
    background-image:
      linear-gradient(135deg, rgba(255, 255, 255, 0.75), rgba(248, 250, 248, 0.5)),
      url('../../assets/images/backgrounds/feeds.jpeg');
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    background-repeat: no-repeat;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dark .background {
    background-image:
      linear-gradient(135deg, rgba(146, 146, 146, 0.75), rgba(179, 179, 179, 0.5)),
      url('../../assets/images/backgrounds/feeds.jpeg');
  }

  .text-divider {
    margin: 2em 0;
    line-height: 0;
    text-align: center;
    color: gray;
    padding: 0px 5px;
  }
  .text-divider span {
    background-color: rgb(255, 255, 255);
    padding: 0 0.5em;
  }
  .text-divider:before {
    content: " ";
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid gray;
    border-bottom: 1px solid #f7f7f7;
  }
  .text-divider span:before  {
    content: "";
    display: block;
    margin-top: -3px;
  }
  .text-divider span:after  {
    display: block;
    margin-top: -3px;
  }
  .dark {
    .text-divider {
      color: var(--iq-light);
    }
    .text-divider span {
      background-color: var(--iq-dark-card-bg);
    }
    .text-divider:before {
      border-top: 1px solid var(--iq-light);
      border-bottom: 1px solid var(--iq-dark-card-bg);
    }
  }
</style>
